import { render, staticRenderFns } from "./CompanyQuestionTwo.vue?vue&type=template&id=7ab70456&scoped=true&"
import script from "./CompanyQuestionTwo.vue?vue&type=script&lang=js&"
export * from "./CompanyQuestionTwo.vue?vue&type=script&lang=js&"
import style0 from "./CompanyQuestionTwo.vue?vue&type=style&index=0&id=7ab70456&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab70456",
  null
  
)

export default component.exports